import { Resolver, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useSelector } from 'react-redux';
import { getLegalResidentInitialValues } from '../utils.ts';
import { validationSchemaLegalResidentGeneralInfo } from '../validationSchema.ts';
import * as yup from 'yup';
import { cloneDeep } from 'lodash';
import { TGeneralInfoLegalResident } from '../types.ts';
import { useFeatureFlags } from '~/helpers/FeatureFlagsContext.tsx';
import { selectGeneralInfo } from '~/store/identification-form/selectors.ts';

export const useGeneralInfoLegalResidentForm = () => {
  const generalInfo = useSelector(selectGeneralInfo);
  const { isAdditionalInformationAboutTaxResidencyEnabled } = useFeatureFlags();

  const initialValues = getLegalResidentInitialValues(
    generalInfo as TGeneralInfoLegalResident,
    isAdditionalInformationAboutTaxResidencyEnabled
  );

  const schema = yup.lazy(() =>
    validationSchemaLegalResidentGeneralInfo(isAdditionalInformationAboutTaxResidencyEnabled)
  );

  const form = useForm<TGeneralInfoLegalResident>({
    resolver: yupResolver(schema) as unknown as Resolver<TGeneralInfoLegalResident>,
    mode: 'onTouched',
    reValidateMode: 'onChange',
    shouldUnregister: false,
    defaultValues: cloneDeep(initialValues),
  });

  return form;
};
